import { t } from '@lingui/core/macro';
import { SearchTypeEnum } from 'shared/domains/apollo/generated/types';
/**
 * @returns Allowed values for search type modifier with name and description.
 */
export const searchTypeValues = () => [
    {
        id: SearchTypeEnum.AutocompleteName,
        name: t({ message: 'Default', comment: 'Universal search - search type: Autocomplete' }),
        description: t({
            message: 'Search by title',
            comment: 'Universal search - search type autocomplete name',
        }),
    },
    {
        id: SearchTypeEnum.All,
        name: t({ message: 'All', comment: 'Universal search - search type: All' }),
        description: t({ message: 'Match all words in any order', comment: 'Universal search - search type: All' }),
    },
    {
        id: SearchTypeEnum.Any,
        name: t({ message: 'Any', comment: 'Universal search - search type: Any' }),
        description: t({ message: 'Match any word in any order', comment: 'Universal search - search type: Any' }),
    },
    {
        id: SearchTypeEnum.Phrase,
        name: t({ message: 'Phrase', comment: 'Universal search - search type: Phrase' }),
        description: t({
            message: 'Match all word in the specified order',
            comment: 'Universal search - search type: Phrase',
        }),
    },
    {
        id: SearchTypeEnum.ExactName,
        name: t({ message: 'Exact name', comment: 'Universal search - search type: Exact' }),
        description: t({ message: 'Match the name exactly', comment: 'Universal search - search type: Exact' }),
    },
];
